import React, { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function AdminLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { path: "/admin", icon: "🏠", label: "Dashboard" },
    { path: "/admin/pages", icon: "📄", label: "Pages" },
    { path: "/admin/homepage", icon: "🏠", label: "Homepage" },
    {
      path: "/admin/corporate-training",
      icon: "🏢",
      label: "Corporate Training",
    },
    { path: "/admin/programs", icon: "🎓", label: "Programs" },
    { path: "/admin/insights", icon: "📝", label: "Insights" },
    { path: "/admin/blog", icon: "📝", label: "Blog" },
    { path: "/admin/subscribers", icon: "📧", label: "Subscribers" },
    { path: "/admin/contact-messages", icon: "✉️", label: "Contact Messages" },
    { path: "/admin/media", icon: "🖼️", label: "Media" },
    { path: "/admin/settings", icon: "⚙️", label: "Settings" },
  ];

  const handleLogout = () => {
    // In real app, clear auth token
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile sidebar toggle */}
      <div className="md:hidden bg-white shadow">
        <div className="flex justify-between items-center px-4 py-3">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <div className="text-xl font-bold text-blue-600">Innobig Admin</div>
          <div className="w-6"></div>
        </div>
      </div>

      <div className="flex">
        {/* Sidebar for desktop */}
        <div
          className={`${sidebarOpen ? "block" : "hidden"} md:block md:w-64 bg-gray-800 text-white fixed md:relative inset-y-0 left-0 z-50`}
        >
          <div className="p-4 border-b border-gray-700">
            <div className="flex items-center">
              <div className="text-2xl font-bold">Innobig</div>
              <div className="ml-2 text-sm bg-blue-600 px-2 py-1 rounded">
                Admin
              </div>
            </div>
          </div>

          <nav className="p-4">
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center px-4 py-3 rounded-lg hover:bg-gray-700 ${
                      location.pathname === item.path ? "bg-blue-600" : ""
                    }`}
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="text-xl mr-3">{item.icon}</span>
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-4 border-t border-gray-700">
              <Link
                to="/"
                target="_blank"
                className="flex items-center px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 rounded"
              >
                <span className="mr-3">👁️</span>
                View Website
              </Link>
              <button
                onClick={handleLogout}
                className="flex items-center px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 rounded w-full mt-2"
              >
                <span className="mr-3">🚪</span>
                Logout
              </button>
            </div>
          </nav>
        </div>

        {/* Overlay for mobile sidebar */}
        {sidebarOpen && (
          <div
            className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setSidebarOpen(false)}
          ></div>
        )}

        {/* Main content */}
        <div className="flex-1">
          {/* Top bar for desktop */}
          <div className="hidden md:block bg-white shadow">
            <div className="flex justify-between items-center px-6 py-4">
              <h1 className="text-2xl font-semibold text-gray-800">
                {menuItems.find((item) => item.path === location.pathname)
                  ?.label || "Dashboard"}
              </h1>
              <div className="flex items-center space-x-4">
                <div className="text-gray-600">
                  Welcome, <span className="font-semibold">Admin</span>
                </div>
                <button
                  onClick={() => navigate("/")}
                  className="text-blue-600 hover:text-blue-800"
                >
                  👁️ View Site
                </button>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-4 md:p-6">{children || <Outlet />}</div>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
